var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BaseModule } from './../commons/BaseModule';
import { getAppInstance } from '@/modules/app';
import RouterModule from '@/modules/router';
var ErrorTrackingModule = (function (_super) {
    __extends(ErrorTrackingModule, _super);
    function ErrorTrackingModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorTrackingModule.prototype.preInstall = function (options) {
        return new Promise(function (resolve, reject) {
            var routerModule = getAppInstance().getModuleByType(RouterModule);
            resolve(true);
        });
    };
    ErrorTrackingModule.prototype.finalizeInstall = function (options) {
        return new Promise(function (resolve, reject) {
            resolve(true);
        });
    };
    ErrorTrackingModule.prototype.captureException = function (error) {
    };
    return ErrorTrackingModule;
}(BaseModule));
export default ErrorTrackingModule;
export function globalCaptureException(error) {
    var errorTrackingModule = getAppInstance().getModuleByType(ErrorTrackingModule);
    errorTrackingModule.captureException(error);
}



//////////////////
// WEBPACK FOOTER
// ./src/modules/error-tracking/index.ts
// module id = null
// module chunks = 